import { Box, Snackbar } from "@mui/material";
import { useState } from "react";
import Email from "./contact-icons/email.png";
import Linkedin from "./contact-icons/linkedin.png";
import Github from "./contact-icons/github.png";
import Goodreads from "./contact-icons/goodreads.png";

const ContactMethods = () => {
  const [emailCopied, setEmailCopied] = useState(false);

  const onIconClick = (src: string) => {
    switch (src) {
      case "github":
        window.open("https://github.com/jan-bock", "_blank") ||
          window.location.assign("https://github.com/jan-bock");
        break;
      case "linkedin":
        window.open("https://www.linkedin.com/in/j-bock/", "_blank") ||
          window.location.assign("https://www.linkedin.com/in/j-bock/");
        break;
      case "goodreads":
        window.open(
          "https://www.goodreads.com/user/show/131021907-jan-bock",
          "_blank",
        ) ||
          window.location.assign(
            "https://www.goodreads.com/user/show/131021907-jan-bock",
          );
        break;
      case "email":
        navigator.clipboard
          .writeText("j.g.bock@outlook.com")
          .then(() => setEmailCopied(true));
        break;
      default:
        break;
    }
  };

  return (
    <Box
      className="contact-container"
      sx={{
        display: "flex",
        flexDirection: "row",
        columnGap: "10px",
        position: "absolute",
        bottom: "15%",
        ":hover": { cursor: "pointer" },
      }}
    >
      <img
        className="contact-icons"
        onClick={() => onIconClick("github")}
        id="github"
        src={Github}
        alt="github icon"
      />
      <img
        className="contact-icons"
        onClick={() => onIconClick("linkedin")}
        src={Linkedin}
        alt="linkedin icon"
      />
      <img
        className="contact-icons"
        onClick={() => onIconClick("email")}
        src={Email}
        alt="email icon"
      />
      <img
        className="contact-icons"
        id="goodreads-icon"
        onClick={() => onIconClick("goodreads")}
        src={Goodreads}
        alt="goodreads icon"
      />
      <Snackbar
        open={emailCopied}
        autoHideDuration={2500}
        onClose={() => setEmailCopied(false)}
        message="Email copied to clipboard"
      />
    </Box>
  );
};

export default ContactMethods;
